import React from 'react';
// Weave's Input component comment suggests not to use it if the default value is tied to state
// In this case, we need to be able to set the value based on the clone run selection
// eslint-disable-next-line wandb/no-deprecated-imports
import {Input} from 'semantic-ui-react';

import {FILE_KEY_DELIMITER, Property} from '../../utilTypes';
import {getDisplayName} from './util';

type TextEntryProps = {
  property: Property;
  value: string | number;
  onChange: (event: any, context: any) => void;
};

function getConstraintText(property: Property) {
  let resp = '';
  if (property.type === 'integer') {
    resp += 'Integer required. ';
  }
  if (property.minimum != null) {
    resp += `Minimum: ${property.minimum}. `;
  }
  if (property.maximum != null) {
    resp += `Maximum: ${property.maximum}. `;
  }
  if (property.exclusiveMinimum != null) {
    resp += `Exclusive minimum: ${property.exclusiveMinimum}. `;
  }
  if (property.exclusiveMaximum != null) {
    resp += `Exclusive maximum: ${property.exclusiveMaximum}. `;
  }
  return resp;
}

export const TextEntry = ({property, value, onChange}: TextEntryProps) => {
  function isError(): boolean {
    if (typeof value === 'number') {
      if (property.type === 'integer' && !Number.isInteger(value)) {
        return true;
      }
      return (
        (property.minimum != null && value < property.minimum) ||
        (property.maximum != null && value > property.maximum) ||
        (property.exclusiveMinimum != null &&
          value <= property.exclusiveMinimum) ||
        (property.exclusiveMaximum != null &&
          value >= property.exclusiveMaximum)
      );
    } else if (typeof value === 'string') {
      if (property.type !== 'string') {
        return true;
      }
    }
    return false;
  }

  return (
    <div
      className="m-0 flex flex-col text-sm"
      key={property.key}
      data-test={property.key}>
      <div
        className="w-fit items-center rounded px-4 text-sm font-normal leading-6 text-sienna-500"
        style={{fontFamily: 'Source Code Pro, monospace'}}>
        {getDisplayName(property)}
      </div>
      <div className="mt-10 text-sm font-normal leading-6 text-moon-500">
        {property.description}
      </div>
      <div className="mb-10 text-sm font-normal leading-6 text-moon-500">
        {getConstraintText(property)}
      </div>
      <Input
        id={(property.file ?? '') + FILE_KEY_DELIMITER + property.key}
        value={value}
        onChange={onChange}
        type={property.type === 'string' ? 'text' : 'number'}
        error={isError()}
      />
    </div>
  );
};
